module.exports = __webpack_public_path__ + "static/logo-buro-e2398bec976fb69eb6ae8c6db52adbc0.svg";